import { render, staticRenderFns } from "./PeekSlot.vue?vue&type=template&id=5c5d89df&scoped=true&"
import script from "./PeekSlot.vue?vue&type=script&lang=js&"
export * from "./PeekSlot.vue?vue&type=script&lang=js&"
import style0 from "./PeekSlot.vue?vue&type=style&index=0&id=5c5d89df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d89df",
  null
  
)

export default component.exports